import React, { useRef, useState, useEffect, Fragment, createRef } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import * as transactionListActions from './actions';

import PropTypes from 'prop-types'
import classnames from 'classnames';
import { List, WindowScroller, AutoSizer } from 'react-virtualized'
import Transaction from './Transaction';
import Checkbox from '../components/Checkbox';
import Tooltip from '../components/Tooltip'

const TransactionList = ({
  dispatch,
  accounts,
  transactions,
  transactionStack,
  gbsTransactions
}) => {
  const pathname = useLocation().pathname;
  const listRef = useRef(null);
  const inputRef = createRef(null);
  var input = null;

  const filesRefs = {}

  useEffect(() => {
    input = inputRef.current;
  }, [pathname]);

  const emptyRowsRenderer = () => {
    return (
      <div className='pv3 tc gray f5'>
        There are no available transactions.
      </div>
    )
  }

  const rowRenderer = ({ index, key, style }) => {
    return (
      <div key={key} style={style} ref={r => { filesRefs[gbsTransactions[index].transactionId] = r }}>
        <Transaction
          index={index}
          {...gbsTransactions[index]}
        />
      </div>
    )
  }

  const rowCount = gbsTransactions.length

  return (
    <section ref={(el) => { const root = el }} className='relative mb3'>
      <Fragment>
        <div className='flex items-center pv2 gray'>
          <button className='flex-grow-1 w-5'>
            <div className='f5 tc truncate charcoal'></div>
          </button>
          <button className='flex-grow-1 w-20' aria-label={ ('sortBy', 'terms.transactionId') } >
            <div className='f5 tc truncate charcoal'>Transaction ID</div>
          </button>
          <button className='flex-grow-1 w-20' aria-label={ ('sortBy', 'terms.transactionDate') } >
            <div className='f5 tc truncate charcoal'>Transaction Date</div>
          </button>
          <button className='flex-grow-1 w-20' aria-label={ ('sortBy', 'terms.dealType') } >
            <div className='f5 tc truncate charcoal'>Transaction Type</div>
          </button>
          <button className='flex-grow-1 w-15' aria-label={ ('sortBy', 'terms.Amount') }>
            <div className='f5 tc truncate charcoal'>Amount</div>
          </button>
          <button className='flex-grow-1 w-20' aria-label={ ('sortBy', 'terms.priceForToken') } >
            <div className='f5 tc truncate charcoal'>Price for a Token</div>
          </button>
        </div>
        <WindowScroller>
          {({ height, isScrolling, onChildScroll, scrollTop }) => (
            <div className='flex-auto' style={{ background: 'white' }}>
              <AutoSizer disableHeight>
                {({ width }) => (
                  <List
                    ref={listRef}
                    autoHeight
                    width={width}
                    height={height}
                    className='outline-0'
                    aria-label={'gbsTransactionsListLabel'}
                    rowCount={rowCount}
                    rowHeight={36}
                    noRowsRenderer={emptyRowsRenderer}
                    rowRenderer={rowRenderer}
                    isScrolling={isScrolling}
                    onScroll={onChildScroll}
                    scrollTop={scrollTop}
                    data={gbsTransactions} />
                )}
              </AutoSizer>
            </div>
          )}
        </WindowScroller>
      </Fragment>
    </section>
  )
}

const mapStateToProps = state => {
  return {
    accounts: state.accounts,
    transactions: state.transactions,
    transactionStack: state.transactionStack
  };
};

export default connect(mapStateToProps)(TransactionList);
